import { Directive, ElementRef, HostBinding, Input } from '@angular/core';
import { toBoolean } from '..//util/convert';
export class YztTabLabelDirective {
private _disabled = false;
/**
 * @param {?} value
 * @return {?}
 */
set disabled(value: boolean) {
    this._disabled = toBoolean(value);
  }
/**
 * @return {?}
 */
get disabled(): boolean {
    return this._disabled;
  }
/**
 * @param {?} elementRef
 */
constructor(public elementRef: ElementRef) {
  }
/**
 * @return {?}
 */
getOffsetLeft(): number {
    return this.elementRef.nativeElement.offsetLeft;
  }
/**
 * @return {?}
 */
getOffsetWidth(): number {
    return this.elementRef.nativeElement.offsetWidth;
  }
/**
 * @return {?}
 */
getOffsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }
/**
 * @return {?}
 */
getOffsetHeight(): number {
    return this.elementRef.nativeElement.offsetHeight;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[yzt-tab-label]',
  host: {
    '[class.yzt-tabs-tab]': 'true'
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'disabled': [{ type: Input },{ type: HostBinding, args: ['class.yzt-tabs-tab-disabled', ] },],
};
}

function YztTabLabelDirective_tsickle_Closure_declarations() {
/** @type {?} */
YztTabLabelDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
YztTabLabelDirective.ctorParameters;
/** @type {?} */
YztTabLabelDirective.propDecorators;
/** @type {?} */
YztTabLabelDirective.prototype._disabled;
/** @type {?} */
YztTabLabelDirective.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
